/* Sticky ATC — title + ATC + ×; image trigger; scroll near top; resets on refresh; i18n label */
(() => {
  const DEBUG = new URLSearchParams(location.search).has('sticky_atc_debug');
  const log = (...a) => { if (DEBUG) console.log('[sticky-atc]', ...a); };

  // Load on normal + section reloads + SPA nav
  const onReady = (fn) => {
    const run = () => { try { fn(); } catch (e) { console.error('[sticky-atc] init error', e); } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:section:reorder', run);
    window.addEventListener('pageshow', run);
  };

  const ensureUnmount = () => { const old = document.getElementById('sticky-atc'); if (old) old.remove(); };

  // Minimal inline CSS safety net
  const injectInlineCSS = () => {
    if (document.getElementById('sticky-atc-inline-css')) return;
    const style = document.createElement('style');
    style.id = 'sticky-atc-inline-css';
    style.textContent = `
#sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:9999;background:#fff;border-top:1px solid rgba(0,0,0,.08);box-shadow:0 -12px 30px rgba(0,0,0,.08);transform:translateY(100%);opacity:0;transition:transform .25s ease,opacity .25s ease;border-radius:16px 16px 0 0}
#sticky-atc.is-visible{transform:translateY(0);opacity:1}
#sticky-atc .sticky-atc__inner{max-width:1200px;margin:0 auto;padding:14px 18px;display:grid;grid-template-columns:1fr auto auto;align-items:center;gap:12px}
#sticky-atc .sticky-atc__title{font-weight:700;font-size:15px;line-height:1.1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
#sticky-atc .sticky-atc__btn{appearance:none;border:0;padding:13px 22px;border-radius:10px;font-weight:700;cursor:pointer;background:#9B046F;color:#fff}
#sticky-atc .sticky-atc__btn[disabled]{opacity:.55;cursor:not-allowed}
#sticky-atc .sticky-atc__close{appearance:none;border:0;background:transparent;font-size:22px;line-height:1;padding:6px 8px;cursor:pointer;color:#6b7280;border-radius:8px}
`;
    document.head.appendChild(style);
  };

  // DOM helpers
  const findProductForm = () => {
    const sels = [
      'form[action^="/cart/add"]',
      'product-form form[action^="/cart/add"]','product-form form',
      'form.product-form','form[name="product-form"]','#product-form','form#product-form'
    ];
    for (const s of sels) { const el = document.querySelector(s); if (el) return el; }
    return null;
  };
  const findRealATC = (form) => {
    if (!form) return null;
    const sels = [
      'button[type="submit"][name="add"]','[type="submit"][name="add"]',
      'button[type="submit"].product-form__submit','button[name="add"]',
      'button[type="submit"]','input[type="submit"][name="add"]'
    ];
    for (const s of sels) { const el = form.querySelector(s); if (el) return el; }
    return null;
  };
  const findHeroMedia = () => {
    const sels = [
      '[data-product-media-wrapper] img','.product__media-wrapper img','media-gallery img',
      '.product-media img','.product__media-list img','.gallery__media img','.product__image img',
      'img[src*="/products/"]'
    ];
    for (const s of sels) { const el = document.querySelector(s); if (el) return el; }
    return null;
  };
const findTitleText = () => {
  // 1) Clean/dedupe helper
  const dedupe = (s) => {
    const cleaned = (s || '').replace(/\s+/g, ' ').trim();
    // If the whole string is repeated once (e.g., "ABC ABC"), return one copy
    const m = cleaned.match(/^(.+?)\s+\1$/);
    return m ? m[1] : cleaned;
  };

  // 2) Prefer explicit sources first
  const fromDataAttr = document.querySelector('[data-product-title]')?.getAttribute('data-product-title');
  if (fromDataAttr) return dedupe(fromDataAttr);

  const og = document.querySelector('meta[property="og:title"]')?.getAttribute('content');
  if (og) return dedupe(og);

  // 3) Fall back to visible headings (may contain duplicated spans)
  const h = document.querySelector('h1.product__title, h1.product-title, .product__title, .product-title, main h1, .page-width h1');
  if (h) return dedupe(h.textContent);

  // 4) Last resort: document title
  return dedupe(document.title.replace(/\s+\|.+$/, ''));
};


  // Scroll target just under sticky header/announcement bars
  const getStickyTopOffset = () => {
    const sels = [
      '#shopify-section-announcement-bar','.announcement-bar','.promo-bar',
      'header[role="banner"]','#shopify-section-header','.shopify-section-header-sticky',
      '.header-wrapper','header.site-header','.site-header'
    ];
    let offset = 0;
    for (const s of sels) {
      const el = document.querySelector(s);
      if (!el) continue;
      const cs = getComputedStyle(el);
      const fixedOrSticky = cs.position === 'fixed' || cs.position === 'sticky';
      const rect = el.getBoundingClientRect();
      if (fixedOrSticky && Math.round(rect.top) <= 0) offset += rect.height;
    }
    return offset;
  };
  const scrollToTargetBelowHeader = (el) => {
    const top = (el ? el.getBoundingClientRect().top + window.pageYOffset : 0)
              - getStickyTopOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  const mount = (productForm, realATC, heroMedia) => {
    ensureUnmount();
    injectInlineCSS();

    const bar = document.createElement('div');
    bar.id = 'sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = `
      <div class="sticky-atc__inner">
        <span class="sticky-atc__title"></span>
        <button class="sticky-atc__btn" type="button"></button>
        <button class="sticky-atc__close" type="button" aria-label="Close">×</button>
      </div>
    `;
    document.body.appendChild(bar);

    const titleEl = bar.querySelector('.sticky-atc__title');
    const btnEl   = bar.querySelector('.sticky-atc__btn');
    const closeEl = bar.querySelector('.sticky-atc__close');

    titleEl.textContent = findTitleText();

    // Dismissal resets on refresh (no storage)
    let dismissed = false;
    const hideBar = () => bar.classList.remove('is-visible');
    const showBar = () => { if (!dismissed) bar.classList.add('is-visible'); };
    closeEl.addEventListener('click', () => { dismissed = true; hideBar(); });

    // Preferred label from Liquid i18n (falls back to real button text)
    const i18nLabel = (window.STICKY_ATC_I18N && window.STICKY_ATC_I18N.add_to_cart) || 'Add to cart';

    const syncBtn = () => {
      let label = (realATC && (realATC.textContent || realATC.value) || '').trim();
      if (!label || /add to cart/i.test(label)) label = i18nLabel; // ensure translated text
      btnEl.textContent = label;
      btnEl.disabled = !!(realATC && realATC.disabled);
      btnEl.setAttribute('aria-label', label);
    };
    syncBtn();
    if (realATC) {
      const mo = new MutationObserver(syncBtn);
      mo.observe(realATC, { attributes: true, childList: true, subtree: true });
    }

    // Click: submit real form + scroll to just under the header
    btnEl.addEventListener('click', () => {
      if (realATC && !realATC.disabled) {
        if (typeof productForm?.requestSubmit === 'function') productForm.requestSubmit(realATC);
        else realATC.click();
      }
      const topTarget =
        document.querySelector('[data-product-title]') ||
        document.querySelector('h1.product__title, h1.product-title') ||
        productForm || document.body;
      scrollToTargetBelowHeader(topTarget);
    });

    // Show only after the hero image leaves view (fallbacks included)
    const target = heroMedia || findHeroMedia();
    if (DEBUG) { showBar(); log('DEBUG on. heroMedia:', !!target); return; }

    if (target) {
      const ioImg = new IntersectionObserver((entries) => {
        const e = entries[0]; if (!e) return;
        if (e.isIntersecting) hideBar(); else showBar();
      }, { root: null, threshold: 0, rootMargin: '0px 0px -10% 0px' });
      ioImg.observe(target);
    } else if (realATC) {
      const ioBtn = new IntersectionObserver((entries) => {
        const e = entries[0]; if (!e) return;
        if (e.isIntersecting) hideBar(); else showBar();
      });
      ioBtn.observe(realATC);
    } else {
      const onScroll = () => { if (window.scrollY > 300) showBar(); else hideBar(); };
      window.addEventListener('scroll', onScroll);
      onScroll();
    }
  };

  const init = () => {
    const form = findProductForm();
    const btn  = findRealATC(form);
    const hero = findHeroMedia();
    mount(form, btn, hero);
  };

  onReady(init);
})();
